export default "import { createApp } from 'vue';\nimport App from './App.vue';\nimport './style.css';\n\ncreateApp( App ).mount( '#app' );\n"